import React, { useState, useRef, useEffect } from "react";

type CreditsCardProps = {
  title: string;
  content: React.ReactNode;
};

const CreditsCard = ({ title, content }: CreditsCardProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [content]);

  return (
    <div
      style={{
        backgroundColor: "var(--card-background)",
        borderRadius: "16px",
        margin: "0 var(--size-3)",
        overflow: "hidden",
      }}
    >
      <div
        onClick={() => setIsOpen(!isOpen)}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px 20px 0",
          cursor: "pointer",
        }}
      >
        <span
          style={{
            fontFamily: "var(--secondary-font)",
            textTransform: "uppercase",
            letterSpacing: "0.1em",
            fontSize: "0.75rem",
            color: "var(--green-1)",
          }}
        >
          {title}
        </span>
        <span
          style={{
            fontSize: "1.5rem",
            color: "var(--green-1)",
            transform: isOpen ? "rotate(45deg)" : "none",
            transition: "transform 0.2s ease",
            lineHeight: 1,
            userSelect: "none",
          }}
        >
          +
        </span>
      </div>

      <div
        ref={contentRef}
        style={{
          padding: 0,
          color: "var(--surface-1)",
          textAlign: "left",
          position: "relative",
          maxHeight: isOpen ? `${contentHeight}px` : "80px",
          overflow: "hidden",
          transition: "max-height 0.8s ease",
          maskImage: isOpen
            ? "none"
            : "linear-gradient(to bottom, black 20%, transparent 80%)",
          WebkitMaskImage: isOpen
            ? "none"
            : "linear-gradient(to bottom, black 20%, transparent 80%)",
        }}
      >
        {content}
      </div>
    </div>
  );
};

export default CreditsCard;
